//-----Authentication
export const getProviders = "GET_PROVIDERS";
export const getProvidersSuccess = "GET_PROVIDERS_SUCCESS";
export const register = "REGISTER";
export const registerSuccess = "REGISTER_SUCCESS";
export const registerFail = "REGISTER_FAIL";
export const authRedirect = "AUTH_REDIRECT";
export const authApiRequestError = "AUTH_API_REQUEST_ERROR";
export const checkUserConsent = "CHECK_USER_CONSENT";
export const checkUserConsentSuccess = "CHECK_USER_CONSENT_SUCCESS";
export const updateUserConsent = "UPDATE_USER_CONSENT";
export const updateUserConsentSuccess = "UPDATE_USER_CONSENT_SUCCESS";
export const resetUnlockCode = "RESET_UNLOCK_CODE";
export const resetUnlockCodeSuccess = "RESET_UNLOCK_CODE_SUCCESS";
export const resetUnlockCodeError = "RESET_UNLOCK_CODE_ERROR";
export const resetVerificationCode = "RESET_VERIFICATION_CODE";
export const resetVerificationCodeSuccess = "RESET_VERIFICATION_CODE_SUCCESS";
export const resetVerificationCodeError = "RESET_VERIFICATION_CODE_ERROR";
export const accountMismatch = "ACCOUNT_MISMATCH";
export const accountMatch = "ACCOUNT_MATCH";


//-----Self Service
export const getEntities = "GET_ENTITIES";
export const getEntitiesSuccess = "GET_ENTITIES_SUCCESS";
export const getEntityFields = "GET_ENTITY_FIELDS";
export const getEntityFieldsSuccess = "GET_ENTITY_FIELDS_SUCCESS";
export const reloadEntityFields = "RELOAD_ENTITY_FIELDS";
export const reloadEntityFieldsSuccess = "RELOAD_ENTITY_FIELDS_SUCCESS";
export const saveEntity = "SAVE_ENTITY";
export const saveEntitySuccess = "SAVE_ENTITY_SUCCESS";
export const submitEntity = "SUBMIT_ENTITY";
export const submitEntitySuccess = "SUBMIT_ENTITY_SUCCESS";
export const selfServiceApiRequestError = "SELF_SERVICE_API_REQUEST_ERROR";
export const setActiveEntityFieldModified = "SET_ACTIVE_ENTITY_FIELD_MODIFIED";
export const setActiveEntityFieldErrors = "SET_ACTIVE_ENTITY_FIELD_ERRORS";
export const clearActiveEntityFieldError = "CLEAR_ACTIVE_ENTITY_FIELD_ERROR";
export const downloadDocument = "DOWNLOAD_DOCUMENT";
export const downloadDocumentSuccess = "DOWNLOAD_DOCUMENT_SUCCESS";
export const deleteDocument = "DELETE_DOCUMENT";
export const deleteDocumentSuccess = "DELETE_DOCUMENT_SUCCESS";
export const uploadDocument = "UPLOAD_DOCUMENT";
export const uploadDocumentSuccess = "UPLOAD_DOCUMENT_SUCCESS";
export const gettingIdentificationDocumentTypes = "GETTING_IDENTIFICATION_DOCUMENT";
export const identificationDocumentTypesSuccess = "IDENTIFICATION_DOCUMENT_SUCCESS";
export const downloadingIdentificationDocument = "DOWNLOADING_IDENTIFICATION_DOCUMENT";
export const downloadIdentificationDocumentSuccess = "DOWNLOAD_IDENTIFICATION_DOCUMENT_SUCCESS";
export const uploadingIdentificationDocument = "UPLOADING_IDENTIFICATION_DOCUMENT";
export const uploadIdentificationDocumentSuccess = "UPLOAD_IDENTIFICATION_DOCUMENT_SUCCESS";
export const deleteIdentificationDocumentSuccess = "DELETE_IDENTIFICATION_DOCUMENT_SUCCESS";
export const deletingIdentificationDocument = "DELETING_IDENTIFICATION_DOCUMENT";
export const downloadingDocumentTypeTemplate = "DOWNLOADING_DOCUMENT_TYPE_TEMPLATE";
export const downloadingDocumentTypeTemplateSuccess = "DOWNLOADING_DOCUMENT_TYPE_TEMPLATE_SUCCESS";


export const getUserAccounts = "GET_USER_ACCOUNTS";
export const getUserAccountsSuccess = "GET_USER_ACCOUNTS_SUCCESS";
export const setEntitiesInitialRequestStatus = "SET_ENTITIES_INITIAL_REQUEST_STATUS";
export const setExpandedSections = "SET_EXPANDED_SECTIONS";

export const idVerificationIsEnabled = "ID_VERIFICATION_IS_ENABLED";
export const idVerificationSession = "ID_VERIFICATION_SESSION";
export const idVerificationDecision = "ID_VERIFICATION_DECISION";

export const updateIdentificationDocumentField = "UPDATE_IDENTIFICATION_DOCUMENT_FIELD";
export const addIdentificationDocument = "ADD_IDENTIFICATION_DOCUMENT";
export const idVerificationSkipped = "ID_VERIFICATION_SKIPPED";


//-----Static Data
export const getPortalSettings = "GET_PORTAL_SETTINGS";
export const getPortalSettingsSuccess = "GET_PORTAL_SETTINGS_SUCCESS";
export const getPortalSettingsFallback = "GET_PORTAL_SETTINGS_FALLBACK";
export const getConfigurationSettings = "GET_CONFIGURATION_SETTINGS";
export const getConfigurationSettingsSuccess = "GET_CONFIGURATION_SETTINGS_SUCCESS";
export const getConfigurationSettingsFallback = "GET_CONFIGURATION_SETTINGS_FALLBACK";
export const getCountries = "GET_COUNTRIES";
export const getCountriesSuccess = "GET_COUNTRIES_SUCCESS";
export const getNationalities = "GET_NATIONALITIES";
export const getNationalitiesSuccess = "GET_NATIONALITIES_SUCCESS";
export const getDocumentSettings = "GET_DOCUMENT_SETTINGS";
export const getDocumentSettingsSuccess = "GET_DOCUMENT_SETTINGS_SUCCESS";
export const staticDataApiRequestError = "STATIC_DATA_API_REQUEST_ERROR";
